<style>
  form {
    color: black;
    background-color: rgba(255, 255, 255, 0.192);
    width: 40vw;
    max-width: 500px;
    padding: 1rem;
  }
  form * {
    text-align: left;
  }
  :global(.lump-dashed--form, .lump-solid--form) {
    border-left-color: black!important;
  }
  button.main {
    font-size: 14px;
  }
 
.explainer
{
 font-family: Montserrat;
 font-size: 10px;
 font-weight: bold;
} 
 
 
 
 </style>
<div class="row justify-content-center" style="width: 100%;">
  <!-- <Info infoTitle="what's required from you?" info="
  <p>High Quality ads---both in terms of resolution and content</p>
  <p>A 16 x 9 aspect ratio</p>
  <p>All Content must adhere to our ad guidlines</p>    
  ">
  </Info> -->
</div>
<div class="container center-content">
  <form class="ad-tv-form" on:submit="{ (e) => { uploadAd(e) } }">
    <div class="form-group">
      <input class="form-control" id="ad-title-input" placeholder="Ad Title" bind:value={adTitle} required/>
    </div>
    <div class="form-group">
      <div class="custom-file">
        <input type="file" class="" id="adFile" accept="image/png" required/>
      </div>
      <div class="explainer">
      <p>File Requirements:</p>
      <p>Must be in 16:9 aspect ratio.</p>
      <p>Must be a PNG file.</p>
      Must adhere to our <div class="Tooltip">Advertiser Guidelines
      <span class="Tooltiptext">Images must not depict any obscene images, any aggressive advertising tactics, no images or text depicting scams. Just be nice. Brite Signal reserves the right to take down any image deemed in breach of guidelines</span>
      </div>
      </div>
      <div style="margin: 1.5vh 0;">
        <Zipcodes bind:zipcodeValues={demographic.location.zipcode}></Zipcodes>
      </div>
      <br />
      <br />
      <div style="margin: 1.5vh 0;">
          <div class="form-group">
            <input type="checkbox" style="width: 6%;" bind:checked={showDemographics}> Add targeted demographics
          </div>
          {#if showDemographics}
            <Demographics bind:demographic isAdOwner=true />
          {/if}
      </div>
      <br />
      <br />
      <div class="Tooltip">Number of Days in Campaign <span class="required--input">(*)</span>
        <span class="Tooltiptext">This is how long you want your campaign to stay up.</span>
      </div>
      <div class="lump-dashed--form">
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="lower-bound-socioeconomic-input"
            placeholder="Number of Days"
            bind:value={campaignLengthDays}
            required
          />
        </div>
      </div>
      <br />
      <div class="Tooltip">Campaign Budget <span class="required--input">(*)</span>
      <span class="Tooltiptext">Your campaign budget is how much you want to spend on this ad campaign. Choose a dollar amount, and then select locations until your budget is met.
        (Example: Budget: $100. Location 1 Price: $30 Location 2 Price: $70)</span>
      </div>

      <br />
      <MoneyInput bind:value={cycleBudget} placeholder="Cycle Budget"/>
      {#if errOccured}
        <br>
        {#if errMsg}
          {errMsg}
        {:else}
          An error occured in starting your campaign, please try again later
        {/if}
      {:else if success}
        <br>
        Your campaign has successfully uploaded. Please wait two to three business days for you advertisment to be reviewed
      {/if}
      <div class="form-group">
        <button type="submit" class="main btn btn-primary {uploadLoading ? 'loading' : ''}">
          Submit Ad
        </button>
      </div>
    </div>
  </form>
</div>
<script>
  import { fade, fly } from "svelte-transitions";
  import {getToken} from "../js-core/conn/auth/auth-main"
  import Demographics from "../components/shared/forms/Demographics.svelte"
  import Zipcodes from "../components/shared/forms/Zipcodes.svelte"
  import MoneyInput from "../components/shared/forms/MoneyInput.svelte"
  import getDemographicsModel from "../js-core/models/demographics"
  export let demographic = getDemographicsModel()
  let cycleBudget = null, adTitle = null, fileUploadLabel = null, errOccured = false, success = false, uploadLoading = false, campaignLengthDays, errMsg
  let showDemographics
  async function uploadAd(e) {
    e.preventDefault();
    uploadLoading = true
    success = false
    errOccured = false
    const fileElem = document.querySelector("#adFile");
    const contentType = "image/png";
    const formData = new FormData();
    formData.append("file", fileElem.files[0]);
    formData.append("demographic", JSON.stringify(demographic));
    formData.append("campaignLengthDays", campaignLengthDays);
    formData.append("cycleBudget", cycleBudget);
    formData.append("contentType", contentType);
    formData.append("filename", adTitle);
    const res = await BSFetch("ad-owner/ads/submit-upload", {
      method: "POST",
      headers: {
        authorization: getToken()
      },
      body: formData,
      mode: "cors",
      cache: "no-cache"
    });
    const resBody = await res.json();
    if (res.status === 201) {
      errOccured = false
      uploadLoading = false
      success = true
    } else {
      if (res.status === 400)
        errMsg = resBody.response.status
      console.log(errMsg)
      errOccured = true
      uploadLoading = false
    }
  }
</script>